import * as yup from "yup";

export const signupSchema = yup.object().shape({
  firstname: yup
    .string()
    .min(3, "signup.firstnameMinError")
    .max(15, "signup.firstnameMaxError")
    .required("signup.firstnameReqError"),
  lastname: yup
    .string()
    .min(3, "signup.lastnameMinError")
    .max(15, "signup.lastnameMaxError")
    .required("signup.lastnameReqError"),
  email: yup
    .string()
    .email("signup.emailTypeError")
    .required("signup.emailReqError"),
  password: yup
    .string()
    .min(8, "signup.passwordMinError")
    .required("signup.passwordReqError"),
});

export const loginSchema = yup.object().shape({
  email: yup
    .string()
    .email("login.emailTypeError")
    .required("login.emailReqError"),
  password: yup
    .string()
    .min(8, "login.passwordMinError")
    .required("login.passwordReqError"),
});

export const updateProfileSchema = yup.object().shape({
  firstname: yup.string().min(3).max(15).required(),
  lastname: yup.string().min(3).max(15).required(),
  email: yup.string().email().required(),
});

export const updatePasswordSchema = yup.object().shape({
  newPassword: yup.string().min(8).required(),
  previousPassword: yup.string().min(8).required(),
});
